import {Component, inject, OnInit} from '@angular/core';
import {NotificationService} from "../../../services/notification.service";
import {MatIconButton} from "@angular/material/button";
import {MatIcon} from "@angular/material/icon";
import {MatBadge} from "@angular/material/badge";
import {AsyncPipe} from "@angular/common";
import {LayoutService} from "../../../services/layout.service";

@Component({
  selector: 'app-notification-bell',
  standalone: true,
  imports: [
    MatIconButton,
    MatIcon,
    MatBadge,
    AsyncPipe
  ],
  templateUrl: './notification-bell.component.html',
  styleUrl: './notification-bell.component.scss'
})
export class NotificationBellComponent implements OnInit {
  private notificationService = inject(NotificationService);
  private layoutService = inject(LayoutService);
  unreadCount$ = this.notificationService.unreadCount$;

  ngOnInit(): void {
    this.notificationService.fetchInitialData();
  }

  toggleNotifications(): void {
    this.layoutService.toggleNotifications();
  }
}
